import { defineMessages } from 'react-intl';

export default defineMessages({
    details: {
        id: 'wmic-pe-capability-gateway-common-ho-react.WMICHOWatercraftDetails.Details',
        defaultMessage: 'Details'
    },

});
